<template id="pagination">
  <nav class="wl-container">
    <ul class="pagination pg-blue">
      <li v-if="model.pagination.current_page > 1" class="page-item">
        <a href="#" aria-label="Previous" class="page-link" v-on:click.prevent="prevPage()">
          <span aria-hidden="true">«</span>
        </a>
      </li>

      <li
        v-for="page in pagesNumber()"
        v-bind:key="`page-${page}`"
        v-bind:class="{'active': page == model.pagination.current_page}"
        class="page-item"
      >
        <a
          v-if="page != model.pagination.current_page"
          href="#"
          class="page-link"
          v-on:click.prevent="changePage(page)"
        >{{ page }}</a>
        <span v-else class="page-link">{{ page }}</span>
      </li>

      <li v-if="model.pagination.current_page < model.pagination.total_pages" class="page-item">
        <a href="#" aria-label="Next" class="page-link" v-on:click.prevent="nextPage()">
          <span aria-hidden="true">»</span>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
import IncludeHelperComponent from '../plugins/includeHelperComponent'

export default {
  name: 'v-pagination',
  extends: IncludeHelperComponent,
  props: {
    model: {
      pagination: {
        type: Object,
        required: true,
      },

      filters: {
        type: Object,
        required: true,
      },
    },
    pageRange: {
      type: Number,
      default: 5,
    },

    routeName: {
      type: String,
      required: true,
    },
  },
  methods: {
    pagesNumber() {
      const pagination = this.model.pagination
      const length = pagination.total_pages
      const range = this.pageRange
      const current = pagination.current_page
      const pagesArray = []

      let selectedRangeLow = 1

      if (current - range > 1) {
        selectedRangeLow = current - range
      }

      let selectedRangeHigh = length

      if (current + range < length) {
        selectedRangeHigh = current + range
      }

      for (let i = selectedRangeLow; i <= selectedRangeHigh; i++) {
        pagesArray.push(i)
      }

      return pagesArray
    },
    changePage: function(page) {
      const filters = this.model.filters
      const pagination = this.model.pagination

      if (pagination.current_page === page) {
        return
      }

      this.modifyUrl(page, filters)
      pagination.current_page = page
    },
    prevPage() {
      if (this.selected <= 0) return

      this.model.pagination.current_page--
      this.modifyUrl(this.model.pagination.current_page, this.model.filters)
    },
    nextPage() {
      if (
        this.model.pagination.current_page >= this.model.pagination.total_pages
      )
        return

      this.model.pagination.current_page++
      this.modifyUrl(this.model.pagination.current_page, this.model.filters)
    },
    modifyUrl(currentPage, filters) {
      filters['page'] = currentPage
      filters = this.mapFilter(filters)

      this.$set(this.model, 'filters', filters)
      this.$set(this.model.pagination, 'current_page', parseInt(filters.page))

      this.pushRoute({ name: this.routeName, query: filters })
    },
    mapFilter(filters) {
      const newObject = {}

      Object.keys(filters).map((key, index) => {
        newObject[key] =
          filters[key] !== ' ' &&
          filters[key] !== '' &&
          filters[key] !== undefined
            ? filters[key].toString()
            : ' '
      })

      return newObject
    },
  },
}
</script>
